<template>
  <el-dialog
    :title="$t('courseSchedule.importInfo')"
    :close-on-click-modal="true"
    :close-on-press-escape="true"
    :show-close="true"
    :visible.sync="dialogShow"
    @close="closeDialog"
    width="800px"
    class="schedule-upload-modal-contain"
  >
    <article class="schedule-upload-modal-tools clearfix">
      <el-upload
        class="modal-tools-upload-import"
        ref="scheduleUpload"
        accept=".xls,.xlsx"
        :action="url"
        :show-file-list="false"
        :multiple="false"
        :auto-upload="false"
        :on-change="changeFile"
        :http-request="uploadContractFile"
      >
        <el-input
          v-model="fileName"
          :disabled="true"
          class="import-excel-input"
        ></el-input>
        <el-button
          type="primary"
          icon="el-icon-upload2"
          class="import-button"
          :loading="loading"
          >{{ $t("pop.choseFile") }}</el-button
        >
      </el-upload>
      <el-button
        type="primary"
        icon="el-icon-download"
        @click="downTemplate"
        :loading="downLoading"
        >{{ $t("pop.downloadtemplate") }}</el-button
      >
    </article>
    <article class="schedule-upload-modal-info" v-if="status === 1 || status === -1">
      {{ status == 1 ? $t("pop.mutliuplateSuccess") : $t("pop.mutliuplateError") }}
      <div class="download-a el-icon-cloudy" @click="downLoadFile">{{ downloadName }}</div>
    </article>
    <article class="schedule-upload-modal-footer">
      <el-button @click="closeDialog" :loading="loading || downLoading">{{
        status === 1 ? $t('confirm') : $t('cancel') }}</el-button>
    </article>
  </el-dialog>
</template>

<script>
import dayjs from 'dayjs';
export default {
  props: {
    dialogShow: {
      type: Boolean
    },
    uploadParams: {
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      downLoading: false,
      fileName: '',
      status: 0,
      downloadName: '',
      src: '',
      url: '/classschedule/scheduleTarget/import',
      timeout: null,
    };
  },
  methods: {
    changeFile(file) {
      this.fileName = '';
      this.status = 0
      if (file && file.status === 'ready') {
        this.$refs.scheduleUpload.submit();
      }
    },
    uploadContractFile(params) {
      if (params.file) {
        this.loading = true;
        const formData = new FormData();
        this.fileName = params.file.name;
        this.status = 0;
        formData.append('file', params.file);
        this.$request
          .post(this.url, formData)
          .then((res) => {
            if (res) {
              this.status = res.status;
              const bstr = window.atob(res.data);
              let n = bstr.length;
              const u8arr = new Uint8Array(n);
              while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
              }
              this.loading = false;
              const blob = new Blob([u8arr], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8',
              })
              const url = URL.createObjectURL(blob);
              this.downloadName = this.$t('courseSchedule.yearTemplateDownload2') + 
              dayjs().format('YYYY-MM-DD HH:mm:ss');
              this.src = url;
              this.$refs.scheduleUpload.clearFiles();
            }
          })
          .catch(() => {
            this.loading = false;
            this.status = 0;
            this.$refs.scheduleUpload.clearFiles();
          });
      }
    },
    downLoadFile () {
      const a = document.createElement('a');
      a.download = this.downloadName;
      a.href = this.src;
      document.getElementsByTagName('body')[0].appendChild(a);
      a.click();
      document.getElementsByTagName('body')[0].removeChild(a);
    },
    // 导出模板
    downTemplate() {
      clearTimeout(this.timeout);
      const params = { ...this.uploadParams, fileName: 'schedule_target_template.xlsx' };
      this.downLoading = true;
      this.$request.downloadByPost7(
        '/classschedule/file/downtemplate',
        `${this.$t('courseSchedule.scheduleTemplate') + 
        dayjs().format('YYYY-MM-DD HH:mm:ss')  }.xlsx`,
        params, null, 'xlsx'
      );
      this.$message({
        message: this.$t('courseSchedule.downloading'),
        type: 'success',
      });
      this.timeout = setTimeout(() => {
        this.downLoading = false;
      }, 2000);
    },
    // 取消
    closeDialog() {
      this.dialogShow = false;
      this.$emit('closeUploadChose', { 'isFresh': this.status === 1 });
    },
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
    this.timeout = null;
    this.status = 0;
    this.fileName = '';
    this.downLoading = false;
    this.loading = false;
  },
};
</script>
<style lang="scss" scoped>
.schedule-upload-modal-contain {
  .schedule-upload-modal-tools {
    padding-bottom: 20px;
    border-bottom: 1px dashed #b2b0b4;
    .modal-tools-upload-import {
      float: left;
      width: 70%;
      margin-right: 20px;
      .el-upload {
        width: 100% !important;
      }
      .import-excel-input {
        width: calc(100% - 150px) !important;
      }
    }
    .import-button {
      margin-left: 20px;
    }
    .operate-button {
      float: left;
    }
    .line {
      height: 1px;
      margin: 10px;
    }
  }
  .schedule-upload-modal-info {
    margin: 20px 0;
    border: 1px solid #b2b0b4;
    border-radius: 4px;
    height: 60px;
    padding: 10px;
    font-size: 16px;
    line-height: 40px;
    text-align: center;
    .download-a {
      margin-left: 20px;
      text-indent: 10px;
      color: #409eff;
      cursor: pointer;
    }
  }
  .schedule-upload-modal-footer {
    text-align: center;
    margin-top: 20px;
  }
}
</style>
<style lang="scss">
.schedule-upload-modal-contain {
  .el-upload {
    width: 100% !important;
    padding: 0 !important;
    border-radius: 0 !important;
  }
}
</style>